const practiceArr = [
  {
    prop: "PaperModeExam",
    label: "组卷模式"
  },
  {
    prop: "PaperModeName",
    label: "命题方式"
  },
  {
    prop: "BeginTime1",
    label: "练习时间",
    width: 260
  },
  {
    prop: "IsPublish",
    label: "练习状态"
  },
  {
    prop: "StudentCount",
    label: "应练习人数"
  },
  {
    prop: "onlineCount",
    label: "正在练习人数",
    width: 120
  },
  {
    prop: "haveCount",
    label: "已完成人数"
  },
  {
    prop: "notJoinCount",
    label: "未完成人数"
  },
  {
    prop: "CreateTime1",
    label: "创建时间",
    width: 160
  },
  {
    prop: "UserName",
    label: "组卷人"
  }
];
const examModelArr = [
  {
    label: "全部",
    value: ""
  },
  {
    value: "unified_db",
    label: "智能组卷"
  },
  {
    value: "unified_exam",
    label: "试卷组卷"
  },
  {
    value: "sg_db",
    label: "精准组卷"
  },
  {
    value: "unified_Proportion",
    label: "权重组卷"
  }
];
const examStatusArr = [
  {
    label: "全部",
    value: ""
  },
  {
    value: "0",
    label: "未完成"
  },
  {
    value: "1",
    label: "已完成"
  }
];

const situationArr = [
  {
    prop: "ExamName",
    label: "练习名称",
    width: "160"
  },
  {
    prop: "IsPublish",
    label: "练习状态"
  },
  {
    prop: "studentCount",
    label: "应练习人数"
  },
  {
    prop: "onlineCount",
    label: "正在练习人数"
  },
  {
    prop: "haveCount",
    label: "已完成人数"
  },
  {
    prop: "notJoinCount",
    label: "未完成人数"
  }
];
const kgtAnswerArr = [
  {
    prop: "correct",
    label: "题型",
    width: "160"
  }
];
const ksAnswerArr = [
  {
    prop: "departmentName",
    label: "科室",
    width: "160"
  },
  {
    prop: "studentCout",
    label: "应练习人数"
  },
  {
    prop: "haveCount",
    label: "已练习人数"
  },
  {
    prop: "haveRate1",
    label: "参与率"
  },
  {
    prop: "rightRate1",
    label: "正确率"
  },
  {
    prop: "scoreAve",
    label: "平均成绩"
  }
];
const individualArr = [
  {
    prop: "realname",
    label: "考生名字",
    width: "160"
  },
  {
    prop: "userName",
    width: "140",
    label: "考生账号"
  },
  {
    prop: "departmentName",
    label: "科室"
  },
  {
    prop: "pTitle",
    label: "职称"
  }
];
const recordForm = [
  {
    prop: "completeTime1",
    label: "完成时间"
  },
  {
    prop: "spendTime",
    label: "答题用时(分钟)"
  },
  {
    prop: "doneNum1",
    label: "作答情况(已答/总题数)"
  },
  {
    prop: "rightRate1",
    label: "正确率"
  },
  {
    prop: "Score",
    label: "练习成绩"
  }
];

const exerciseState = [
  {
    prop: "RealName",
    label: "考生姓名"
  },
  {
    prop: "UserName",
    label: "考生账号"
  },
  {
    prop: "DepartmentName",
    label: "科室"
  },
  {
    prop: "PTitle",
    label: "职称"
  },
  {
    prop: "doNum",
    label: "做题情况（已答数）"
  },
  {
    prop: "rightNum2",
    label: "正确率"
  },
  {
    prop: "updateTime",
    label: "最近练习日期"
  }
];
export {
  practiceArr,
  examModelArr,
  examStatusArr,
  situationArr,
  kgtAnswerArr,
  ksAnswerArr,
  individualArr,
  recordForm,
  exerciseState
};
